<div class="tags">
   
    <div [ngClass]="tagClass">
        <div [ngClass]="tagIconClass"></div>
        {{tagTitle}}
    </div>
</div>
